import {BackendData} from "@app/_model/backend.data";
import {Permission, RoleType} from "@app/_model";
import {AccountClient} from "@app/_model/account.client";

/**
 * Felhasználó
 *
 * @class Account
 */
export class Account extends BackendData {
  login: string;
  ldapDN?: string;
  name: string;
  email: string;
  have2fa: boolean;
  permissions?: Permission[];

  accountClients?: AccountClient[];

  token?: string;
  roles?: RoleType[];
  need2fa?: boolean;

  constructor(
    id: number,
    login: string,
    ldapDN: string | undefined,
    name: string,
    email: string,
    have2fa: boolean,
    inserted: Date | undefined,
    insertedBy: Account | undefined,
    updated: Date | undefined,
    updatedBy: Account | undefined,
    accountClients: AccountClient[] | undefined,
    token: string | undefined,
    roles: RoleType[] | string[] | undefined,
    permissions: Permission[] | undefined
  ) {
    super(id, inserted, insertedBy, updated, updatedBy);
    this.login = login;
    this.ldapDN = ldapDN;
    this.name = name;
    this.email = email;
    this.have2fa = have2fa;
    this.accountClients = accountClients;
    this.token = token;
    this.roles = roles?.map(role => RoleType[role as unknown as keyof typeof RoleType]);
    this.permissions = permissions?.map(permission => Permission.of(permission));
    this.log.trace('Account:', this);
  }

  public static of(account: Account | any): Account {
    return new Account(account.id, account.login, account.ldapDN, account.name, account.email, account.have2fa, account.inserted, account.insertedBy, account.updated, account.updatedBy, account.accountClients, account.token, account.roles, account.permissions);
  }
}
